const teamSelector = (teamId: string) => (
    state: sage.state.IRedux
): sage.model.ITeam | undefined => state.teams.teamLookup[teamId];

export default teamSelector;
